module.exports = __webpack_public_path__ + "img/moto.5df7ff7b.png";